import * as Constants from "../common/Constants";
import cloneDeep from "lodash/cloneDeep";

const initialState = {
    stocks: [],
    packs: [],
    stockItems: [],
    allStockItems: [],
    transferStockItems: [],
    newTransferId: null,
    stock: null,
    pendingItems: [],
    receivePendingItem: null,
    filteredStocks: [],
    filteredBranch: [],
    branchStocks: [],
    productStockDetails: [],
    filteredStockItems: [],
    productStockItem: null,
    isLoading: false,
    isPosting: false,
    isPosted: false,
    count: 0,
    page: 1,
    pageSize: 10,
    error: null
};

export default function stockReducer(state = initialState, action) {

    var newState;
    switch (action.type) {

        case Constants.REQUEST_ADD_STOCK_ITEM_AND_PRODUCT:
        case Constants.REQUEST_ADD_STOCK_PRICE:
        case Constants.REQUEST_ADD_STOCK_SALES_INVOICE:
        case Constants.REQUEST_ADD_STOCK:
        case Constants.REQUEST_ADD_STOCK_PACK:
        case Constants.REQUEST_ADD_STOCK_ITEM:
        case Constants.REQUEST_TRANSFER_STOCK_ITEMS:
        case Constants.REQUEST_RECEIVE_STOCK_ITEMS:
        case Constants.REQUEST_APPROVE_STOCK_TRANSFER:
            newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isPosting = true;
            return newState;

        case Constants.SUCCESS_ADD_STOCK_ITEM_AND_PRODUCT:
        case Constants.SUCCESS_ADD_STOCK_PRICE:
        case Constants.SUCCESS_ADD_STOCK_SALES_INVOICE:
        case Constants.SUCCESS_ADD_STOCK:
        case Constants.SUCCESS_ADD_STOCK_PACK:
        case Constants.SUCCESS_ADD_STOCK_ITEM:
        case Constants.SUCCESS_RECEIVE_STOCK_ITEMS:
            newState = { ...state };
            newState.isPosting = false;
            newState.error = null;
            newState.isPosted = true;
            return newState;

        case Constants.FAILED_ADD_STOCK_ITEM_AND_PRODUCT:
        case Constants.FAILED_ADD_STOCK_PRICE:
        case Constants.FAILED_ADD_STOCK_SALES_INVOICE:
        case Constants.FAILED_ADD_STOCK:
        case Constants.FAILED_ADD_STOCK_PACK:
        case Constants.FAILED_ADD_STOCK_ITEM:
        case Constants.FAILED_TRANSFER_STOCK_ITEMS:
        case Constants.FAILED_RECEIVE_STOCK_ITEMS:
        case Constants.FAILED_APPROVE_STOCK_TRANSFER:
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = action.error;
            return newState;

        case Constants.REQUEST_GET_PACK_SIZE:
        case Constants.REQUEST_GET_SINGLE_PRODUCT:
        case Constants.REQUEST_GET_FILTER_STOCK:
        case Constants.REQUEST_GET_STOCKS:
        case Constants.REQUEST_GET_FILTER_BARCODE:
        case Constants.REQUEST_GET_STOCK_ITEM:
        case Constants.REQUEST_GET_SINGLE_STOCK_ITEM:
        case Constants.REQUEST_GET_SINGLE_PENDING_STOCK_ITEM:
        case Constants.REQUEST_GET_FILTER_BRANCH:
        case Constants.REQUEST_GET_SINGLE_PRODUCT_DETAILS:
        case Constants.REQUEST_GET_BRANCH_STOCKS:
        case Constants.REQUEST_GET_PENDING_STOCKS:
            var newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = true;
            newState.isPosting = false;
            return newState;

        case Constants.FAILED_GET_FILTER_STOCK:
        case Constants.FAILED_GET_SINGLE_PRODUCT:
        case Constants.FAILED_GET_STOCKS:
        case Constants.FAILED_GET_PACK_SIZE:
        case Constants.FAILED_GET_FILTER_BARCODE:
        case Constants.FAILED_GET_STOCK_ITEM:
        case Constants.FAILED_GET_SINGLE_STOCK_ITEM:
        case Constants.FAILED_GET_SINGLE_PENDING_STOCK_ITEM:
        case Constants.FAILED_GET_FILTER_BRANCH:
        case Constants.FAILED_GET_SINGLE_PRODUCT_DETAILS:
        case Constants.FAILED_GET_BRANCH_STOCKS:
        case Constants.FAILED_GET_PENDING_STOCKS:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = action.error;
            return newState;

        case Constants.SUCCESS_GET_STOCKS:
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = null;
            newState.stocks = action.stocks.items;
            newState.page = action.stocks.page;
            newState.pageSize = action.stocks.pageSize;
            newState.count = action.stocks.totalCount;
            return newState;

        case Constants.SUCCESS_GET_PACK_SIZE:
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = null;
            newState.packs = action.payload;
            return newState;

        case Constants.SUCCESS_GET_FILTER_STOCK:
            newState = { ...state };
            newState.isPosting = false;
            newState.isLoading = false;
            newState.error = null;
            newState.isPosted = false;
            newState.filteredStocks = action.payload;
            return newState;

        case Constants.SUCCESS_GET_FILTER_BARCODE:
            newState = { ...state };
            newState.isPosting = false;
            newState.isLoading = false;
            newState.error = null;
            newState.isPosted = false;
            newState.filteredStockItems = action.payload;
            return newState;

        case Constants.SUCCESS_GET_STOCK_ITEM:
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = null;
            newState.allStockItems = action.payload;
            return newState;

        case Constants.SUCCESS_GET_SINGLE_STOCK_ITEM:
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = null;
            newState.stockItems = action.payload;
            return newState;

        case Constants.SUCCESS_GET_SINGLE_PRODUCT:
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = null;
            newState.productStockItem = action.payload;
            return newState;

        case Constants.SUCCESS_GET_FILTER_BRANCH:
            newState = { ...state };
            newState.isPosting = false;
            newState.isLoading = false;
            newState.error = null;
            newState.isPosted = false;
            newState.filteredBranch = action.payload;
            return newState;

        case Constants.SUCCESS_GET_SINGLE_PRODUCT_DETAILS:
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = null;
            newState.productStockDetails = action.payload;
            return newState;

        case Constants.SUCCESS_GET_BRANCH_STOCKS:
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = null;
            newState.branchStocks = action.payload;
            return newState;
            
        case Constants.SUCCESS_APPROVE_STOCK_TRANSFER:
            newState = {...state};
            newState.isPosting = false;
            newState.isPosted = true;
            newState.isLoading = false;
            newState.error = null;
            newState.pendingItems = cloneDeep(newState.pendingItems.filter(a => a.stockItemId !== action.payload));
            return newState;

        case Constants.SUCCESS_TRANSFER_STOCK_ITEMS:

            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = true;
            newState.isLoading = false;
            newState.error = null;
            newState.newTransferId = action.payload;
            return newState;

        case Constants.SUCCESS_GET_SINGLE_PENDING_STOCK_ITEM:

            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = null;
            newState.receivePendingItem = action.payload;
            return newState;

        case Constants.SUCCESS_GET_PENDING_STOCKS:
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = null;
            newState.pendingItems = action.payload;
            return newState;

        case Constants.RESET_STOCK:
            return {
                ...state, 
                newTransferId: null,
                branchStocks: [],
                stockItems: [],
                pendingItems: [],
                receivePendingItem:null,
                productStockItem:null,
                isLoading: false,
                isPosting: false,
                isPosted: false,
                error: null
            }

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/StockReducer.js